<template>
  <v-row justify="center">
    <v-dialog v-model="isWindowDisplayed" max-width="800px">
      <template v-slot:activator="{ on, attrs }">
        <v-icon v-bind="attrs" v-on="on" title="Modifier projet">
          {{ iconAdd }}
        </v-icon>
      </template>
      <v-card color="#f0f0f0">
        <v-card-title>
          <span class="text-h5">Modification d'un projet</span>
        </v-card-title>
        <template
          v-if="new Date().getTime() < new Date(project.endDate).getTime()"
        >
          <v-card-text>
            <v-container>
              <v-row>
                <v-row>
                  <v-col cols="5">
                    <v-select
                      :items="[project]"
                      v-model="projectP"
                      item-text="name"
                      item-value="id"
                      name="project"
                      label="Selection du projet"
                      color="#51bdcb"
                      item-color="dark"
                      disabled
                      class="mt-auto"
                    >
                    </v-select>
                  </v-col>
                  <v-col cols="2">
                    <v-select
                      :items="[project]"
                      v-model="projectP"
                      item-text="activity"
                      item-value="activity"
                      name="activity"
                      label="Selection du pôle"
                      color="#51bdcb"
                      item-color="dark"
                      disabled
                      class="mt-auto"
                    >
                    </v-select>
                  </v-col>
                  <v-col cols="4"
                    ><v-text-field
                      type="number"
                      color="#51bdcb"
                      label="Budget simulé"
                      required
                      class="field"
                      v-model="budget"
                      min="0"
                      :rules="numberPositifRules"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="1">
                    <v-tooltip right max-width="300">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on" class="mt-3">
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>
                        Le budget renseigné ne sera pris en compte que s'il
                        s'agit d'un projet simulé qui n'existe pas sur
                        BoondManager, sinon les données de Boond écraserons le
                        budget entré.
                      </span>
                    </v-tooltip>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="5" sm="6">
                    <v-checkbox
                      color="#51bdcb"
                      v-model="boondExist"
                      label="Projet existant sur BoondManager"
                    ></v-checkbox>
                  </v-col>
                  <v-col cols="6" v-if="boondExist">
                    <v-text-field
                      v-model="boondID"
                      color="#51bdcb"
                      label="ID BoondManager du Projet"
                      class="field"
                      :rules="IDRules"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-row>
              <v-row v-if="blankError">
                <v-col>
                  <v-alert
                    border="right"
                    colored-border
                    type="error"
                    elevation="2"
                  >
                    Veuillez remplir tous les champs s'il vous plaît
                  </v-alert>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </template>
        <template v-else>
          <p class="text-center text-h6 px-auto mt-10">
            Ce projet est terminé depuis le
            {{ new Date(project.endDate).toLocaleDateString() }}.
          </p>
          <p class="text-center text-h6 px-auto pb-5">
            Le modifier n'est plus possible !
          </p>
        </template>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#51bdcb" text @click="closeWindow"> Annuler </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <template v-if="isErrorMessageDisplayed"> <PopUpError /></template>
  </v-row>
</template>

<script>
import { UPDATE_PROJECT } from '../graphql/GraphQLMutations';
import { GET_ALL_PROJECTS } from '../graphql/GraphQLQueries';
import PopUpError from './PopUpError.vue';

const _ = require('lodash');

export default {
  name: 'ModalUpdateProject',

  components: {
    PopUpError,
  },

  data: () => ({
    isWindowDisplayed: false,
    iconAdd: 'mdi-pencil',
    boondExist: false,
    blankError: false,
    boondID: -1,
    budget: 1,
    projectP: {},
    numberPositifRules: [
      (v) => !!v || 'Le budget doit être rempli',
      (v) =>
        /^\d*[1-9]\d*$/.test(v) ||
        'Le budget doit être positif et différent de 0',
    ],

    IDRules: [
      (v) => !!v || "L'ID doit être rempli",
      (v) =>
        /^\d*[1-9]\d*$/.test(v) ||
        "L'ID doit être positif et différent de -1 et 0",
    ],
    reg: /^\d*[1-9]\d*$/,
    isErrorMessageDisplayed: false,
  }),

  props: {
    project: {
      type: Object,
      required: true,
    },
  },
  mounted() {
    if (this.project) {
      this.projectP = this.project;
    }
  },

  methods: {
    closeWindow() {
      this.budget = 1;
      this.boondExist = false;
      this.blankError = false;
      this.boondID = -1;
      this.isWindowDisplayed = false;
    },
    updateProject() {
      // reset error
      this.isErrorMessageDisplayed = false;
      const { name } = this.project;
      const budget = parseInt(this.budget, 10);
      const { activity } = this.project;
      let boondmanagerId = parseInt(this.boondID, 10);
      if (!this.boondExist) {
        boondmanagerId = -1;
      }
      const { startDate } = this.project;
      const { endDate } = this.project;
      const { id } = this.project;

      const input = {
        name,
        budget,
        activity,
        boondmanagerId,
        startDate,
        endDate,
      };
      if (
        this.reg.test(budget) &&
        ((this.boondExist && this.reg.test(this.boondID)) || !this.boondExist)
      ) {
        this.$apollo
          .mutate({
            mutation: UPDATE_PROJECT,
            variables: {
              id,
              input,
            },
            update: (cache, { data: { updateProject } }) => {
              const data = cache.readQuery({ query: GET_ALL_PROJECTS });
              const index = _.findIndex(data.getAllProjects, {
                id: updateProject.id,
              });
              data.getAllProjects.splice(index, 1, updateProject);
              cache.writeQuery({ query: GET_ALL_PROJECTS, data });
            },
          })
          .then(() => {
            this.isWindowDisplayed = false;
          })
          .catch(() => {
            this.isErrorMessageDisplayed = true;
          });
      } else {
        this.blankError = true;
      }
    },
  },
};
</script>
